import { Fragment } from 'react';

/** Заголовки верхнего уровня: «5. Права и обязанности…» / «Приложение №1 …»,
 *  но не номера пунктов вида «5.1. …». */
const isHeading = (line: string) =>
  (/^\d+\.\s+\D/.test(line) && !/^\d+\.\d/.test(line)) || line.startsWith('Приложение');

const URL_RE = /https?:\/\/\S+/g;

/** Абзац с кликабельными URL (канонические адреса редакций в текстах юриста).
 *  Хвостовая пунктуация после адреса ссылкой не считается. */
function linkify(text: string) {
  const parts: React.ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(URL_RE)) {
    const trailing = /[.,;:)!?»]+$/.exec(m[0])?.[0] ?? '';
    const url = m[0].slice(0, m[0].length - trailing.length);
    parts.push(text.slice(last, m.index));
    parts.push(
      <a key={m.index} href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>,
    );
    last = m.index + url.length;
  }
  if (!parts.length) return text;
  parts.push(text.slice(last));
  return parts.map((p, i) => <Fragment key={i}>{p}</Fragment>);
}

/** Юридический документ (оферта, согласие на ПДн) плоскими абзацами:
 *  строка = абзац, заголовки разделов — <h4>. Стили — .terms-card. */
export function LegalText({ text }: { text: string }) {
  const blocks = text
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);
  return (
    <>
      {blocks.map((line, key) =>
        isHeading(line) ? <h4 key={key}>{line}</h4> : <p key={key}>{linkify(line)}</p>,
      )}
    </>
  );
}
